import React from "react";
import Helmet from "react-helmet";
import Head from "../../components/Partials/Head";
import { getCurrentLanguage } from '../../assets/js/functions';

const DeafaultLayout = ({ pageMeta, children }) => {
  const lang = getCurrentLanguage();

  const childrenWithProps = React.Children.map(children, (child) =>
    React.isValidElement(child) ? React.cloneElement(child, { lang }) : child
  );

  return (
    <>
      <Helmet>
        <html className="h-100" lang={getCurrentLanguage()} />
        {pageMeta.desc ? (
          <meta name="description" content={pageMeta.desc} />
        ) : (
          ""
        )}
        <Head />
        <body id="top" className="is-size-6" />
      </Helmet>

      {childrenWithProps}

    </>
  );
};

export default DeafaultLayout;